import { FC, ReactNode, useEffect, useRef } from 'react'
import Text from '@organisms/Text'
import ConfirmModalContent from '@organisms/ConfirmModalContent'
import PrimaryButton from '@organisms/PrimaryButton'
import SecondaryButton from '@organisms/SecondaryButton'
import { ButtonsWrapper, SuccessWrapper } from './styled'

type Props = {
  onClose?: () => void
  onAddMore?: () => void
  addTitle: string
  editTitle: string
  description: ReactNode
  isEdit: boolean
  withoutAddMore?: boolean
}

// Экран успеха показывается в общем (широком, рассчитанном на форму) белом блоке
// #modal. Пока открыт экран успеха, сужаем этот блок под контент, чтобы вокруг не было
// пустого поля, а крестик стоял рядом с текстом. Инлайн-стиль перебивает ширину формы
// и возвращается к исходному при закрытии окна или возврате к форме («Добавить ещё»).
const COMPACT_MODAL_WIDTH = 'min(640px, calc(100vw - 40px))'

const SuccessContent: FC<Props> = ({
  onClose,
  onAddMore,
  addTitle,
  editTitle,
  description,
  isEdit,
  withoutAddMore = false,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const modal = wrapperRef.current?.closest<HTMLElement>('#modal')

    if (!modal) {
      return undefined
    }

    const prevWidth = modal.style.width
    const prevMinWidth = modal.style.minWidth

    modal.style.width = COMPACT_MODAL_WIDTH
    modal.style.minWidth = '0'

    return () => {
      modal.style.width = prevWidth
      modal.style.minWidth = prevMinWidth
    }
  }, [])

  return (
    <SuccessWrapper ref={wrapperRef}>
      <ConfirmModalContent
        leftIcon="success-bear-new.svg"
        title={isEdit ? editTitle : addTitle}
        rightContent={
          <>
            <Text>{description}</Text>
            <ButtonsWrapper>
              {!withoutAddMore && !isEdit && onAddMore && (
                <SecondaryButton onClick={onAddMore} big>
                  Добавить еще
                </SecondaryButton>
              )}
              <PrimaryButton onClick={onClose} big>
                Закрыть
              </PrimaryButton>
            </ButtonsWrapper>
          </>
        }
      />
    </SuccessWrapper>
  )
}

export default SuccessContent
